import React, { useEffect } from "react";
import "./Dashboard.css";
import { NavLink } from "react-router-dom";
import { Zap } from "lucide-react";
import { ReactComponent as BankingAalytics } from "../../icons/dashboard/bankingAnalytics.svg";
import { ReactComponent as ConsumptionAndGenerationAnalytics } from "../../icons/dashboard/consumptionAndGenerationAnalytics.svg";
import { ReactComponent as DemandForecasting } from "../../icons/dashboard/demandForecasting.svg";
import { ReactComponent as DiscomAnalysis } from "../../icons/dashboard/discomAnalysis.svg";
import { ReactComponent as ExchangeAnalysis } from "../../icons/dashboard/exchangeAnalysis.svg";
import { ReactComponent as GridFrequencyProfile } from "../../icons/dashboard/gridFrequencyProfile.svg";
import { ReactComponent as MarketMonitoring } from "../../icons/dashboard/marketmonitoring.svg";
import { ReactComponent as PowerAtlas } from "../../icons/dashboard/powerAtlas.svg";
import { ReactComponent as PriceForecasting } from "../../icons/dashboard/priceForecasting.svg";
import { ReactComponent as TraderIcon } from "../../icons/dashboard/traderImage.svg";
import { getSessionValidity } from "../../Rest_api/RestApi";
import Hamburger from "../../components/Hamburger";
import { ProtectedPage } from "../Protected";

function DashBoardItem({
  title,
  Icon,
  to,
}: {
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  to: string;
}) {
  return (
    <NavLink to={`${to}`} className="dashboard-item">
      <Icon
        style={{
          fill: "white",
        }}
      />
      <p>{title}</p>
    </NavLink>
  );
}
export default function Dashboard() {
  useEffect(() => {
    localStorage.removeItem("procurement_edit_id");
    getSessionValidity().then((res) => {
      if (res.session_type == "derivative") {
        window.location.href = "/derivative";
        return;
      }
      if (res.status == false) {
        // swal("Session Expired", "Please login again", "warning");
        localStorage.clear();
        window.location.href = "/login";
      }
    });
  }, []);
  return (
    <>
      {" "}
      <div className="dashboard-header flex justify-between items-center relative">
        <div className="absolute left-4">
          <Hamburger />
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <div className="w-full text-center">
            <h1 className="text-[#6F6D7C] !text-[18px]">
              GNA Energy Data and Analytics Capability Center (GDACC)
            </h1>
          </div>
        </div>
      </div>
      <div className="dashboard-item-container justify-between flex flex-col">
        <div className="flex flex-row flex-wrap gap-5 justify-center">
          <ProtectedPage showPopUp={false} pageId="marketmonitoring">
            <DashBoardItem
              Icon={MarketMonitoring}
              title="Market Monitoring"
              to="marketmonitoring"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="exchangeAnalysis">
            <DashBoardItem
              Icon={ExchangeAnalysis}
              title="Exchange Analytics"
              to="exchangeAnalysis?module=Exchange+Analytics&tab=Collective"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="auctions">
            <DashBoardItem
              Icon={BankingAalytics}
              title="TAM and DEEP"
              to="auctions"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="poweratlas">
            <DashBoardItem
              Icon={PowerAtlas}
              title="Power Atlas"
              to="powerAtlas"
            />
          </ProtectedPage>
          <ProtectedPage
            showPopUp={false}
            pageId="consumptionandgenerationanalytics"
          >
            <DashBoardItem
              Icon={ConsumptionAndGenerationAnalytics}
              title="Consumption and Generation Analytics"
              to="consumptionAndGenerationAnalytics"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="discomAnalysis">
            <DashBoardItem
              Icon={DiscomAnalysis}
              title="Discom Analytics"
              to="discomAnalysis"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="priceforecasting">
            <DashBoardItem
              Icon={PriceForecasting}
              title="Price Forecast"
              to="priceForecasting"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="demandforecasting">
            <DashBoardItem
              Icon={DemandForecasting}
              title="Demand Forecast"
              to="demandForecasting"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="gas">
            <DashBoardItem
              Icon={GridFrequencyProfile}
              title="Gas Analytics"
              to="gas"
            />
          </ProtectedPage>
          <ProtectedPage showPopUp={false} pageId="powerAnalysis">
            <DashBoardItem
              Icon={ExchangeAnalysis}
              title="Power Analytics"
              to="powerAnalysis"
            />
          </ProtectedPage>
          {/* <ProtectedPage showPopUp={false} pageId="trader">
          <DashBoardItem Icon={TraderIcon} title="Trader" to="trader" />
          </ProtectedPage> */}
        </div>
        <div className="copyright-text">
          2026 GNA Energy Private Limited. All Rights Reserved
        </div>
      </div>

      <NavLink
        to="exchangeAnalysis?module=Vidyut+AI"
        title="Vidyut AI"
        className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-3 py-2 rounded-full text-xs font-medium text-white/80 hover:text-white transition-all duration-200"
        style={{
          background: "rgba(15, 32, 39, 0.85)",
          border: "1px solid rgba(241,147,92,0.25)",
          boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
          backdropFilter: "blur(8px)",
        }}
      >
        <Zap size={13} className="text-[#f1935c]" fill="#f1935c" />
        <span className="tracking-wide">Vidyut AI</span>
      </NavLink>
    </>
  );
}
